import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Item = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 25px 15px;
`;

export const Text = styled(Typography.Body)<{ $isRed?: boolean }>`
  margin-left: 10px;
  color: ${({ theme, $isRed }) =>
    $isRed ? theme.palette.system.red : theme.palette.primary.labels};
`;

export const Form = styled.form`
  display: grid;
  gap: 30px;
  padding-bottom: 20px;
`;
